import { Injectable } from '@angular/core';
import { UnauthorizedErrorHandler } from '@core/services/error-handlers/unauthorized-error-handler.interface';

@Injectable({ providedIn: 'root' })
export class UnauthorizedErrorHandlerRegistry {
  private _handler: UnauthorizedErrorHandler | null = null;

  register(handler: UnauthorizedErrorHandler): void {
    this._handler = handler;
  }

  get handler(): UnauthorizedErrorHandler | null {
    return this._handler;
  }
}
